import {
  Flex,
  Heading,
  useColorModeValue,
  Image,
  Text,
} from "@chakra-ui/react";
import React from "react";
import { useNavigate } from "react-router-dom";
import { BookingLocation } from "../../data/occupancy.api";
import placeholderImg from "../../assets/event-placeholder.jpg";

type Props = {
  location: BookingLocation;
  datetime?: string;
};

const LocationCard = ({ location, datetime }: Props) => {
  const navigate = useNavigate();
  const bg = useColorModeValue("gray.50", "gray.700");
  const hoverColour = useColorModeValue("gray.100", "gray.600");

  return (
    <Flex
      border="1px solid rgba(0, 0, 0, 0.1)"
      rounded="md"
      overflow="hidden"
      role="group"
      bg={bg}
      cursor="pointer"
      transition=".1s all"
      _hover={{ bg: hoverColour }}
      onClick={() =>
        navigate(
          `/book/${location.key}` + (datetime ? `?datetime=${datetime}` : "")
        )
      }
    >
      <Flex p={5} flex={1} gap={3}>
        <Flex direction="column" flex={1}>
          <Heading size="sm">{location.name}</Heading>
          <Text fontSize="xs" opacity={0.7}>
            {location.buildingName}, {location.spaceNumber}
          </Text>
          <Text fontSize="xs" opacity={0.5}>
            Capacity: {location.capacity ? location.capacity : "Unknown"}
          </Text>
        </Flex>
      </Flex>
      <Image
        src={location.images?.[0]?.url ?? placeholderImg}
        alt={`${location.name}`}
        filter={location.images?.[0]?.url ? undefined : "grayscale(100%)"}
        objectFit="cover"
        w={24}
      />
    </Flex>
  );
};

export default LocationCard;
